import Immutable from 'seamless-immutable'
import * as actions from './actions'

export const initialState = Immutable.from({ inventory: null, heroAdDisplayed: false })

const StartPage = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_INVENTORY_DATA:
      return {
        ...state,
        inventory: payload,
      }
    case actions.SET_HERO_AD_DISPLAYED_STATUS:
      return {
        ...state,
        heroAdDisplayed: payload,
      }
    default:
      return state
  }
}

export default StartPage
